import React from 'react';
import clsx from 'clsx';
import SearchIcon from '@mui/icons-material/Search';
// import './style.css';

function SearchGroupField(props) {
  const {
    placeholder = 'Search...',
    title = 'Search',
    name = 'search',
    id = 'search',
    error,
    onChange = () => {},
    value,
    className,
    onKeyPress,
    onMouseDown,
    onBlur,
    ref,
  } = props;

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', width: '0%', flexGrow: '1.5',
    }}
    >
      <div className="Input-headingcontainer01-search">
        <props className="input-div">
          {title}
        </props>
      </div>
      <div className="search-input-container-search">
        <SearchIcon className="search-icon-search" />
        <input
          type="text"
          placeholder={placeholder}
          value={value}
          onBlur={onBlur}
          name={name}
          onMouseDown={onMouseDown}
          id={id}
          className={clsx(className, 'input-new-search')}
          onChange={(e) => onChange(e)}
          onKeyPress={onKeyPress}
          ref={ref}
        />
      </div>
      {error && <p className="InputErrorMsg-search">{error}</p>}
    </div>
  );
}

export default SearchGroupField;
